// Lazy-load Vimeo / YouTube embed iframes: defer the iframe — and the heavy
// player runtime + full-size poster it pulls in — until it scrolls near the
// viewport. This is the iframe counterpart of load_html5_videos_controller.js.
//
// video.php renders the iframe with `data-src` instead of `src` and marks it
// `.lay-iframe-lazyload` when the per-provider "Use Lazy Loading for Vimeo /
// YouTube videos" option is on. Here we restore `src` on intersection.

var loadIframe = function (iframe) {
	if (!iframe || !iframe.dataset || iframe.dataset.src == undefined || !iframe.parentNode) {
		return
	}

	var src = iframe.dataset.src

	// Swap in a FRESH iframe that already has the src, instead of assigning
	// iframe.src on the existing (blank) one. Navigating an existing iframe via
	// JS pushes a browser session-history entry — combined with the project
	// overlay's own History API use that produces the "click back twice" bug
	// (the very reason iframe lazyloading was disabled for overlays, see
	// video.php). A newly created iframe's first load is an initial navigation
	// and adds no history entry.
	var fresh = iframe.cloneNode(true)
	fresh.removeAttribute('data-src')
	fresh.setAttribute('src', src)
	fresh.classList.remove('lay-iframe-lazyload')
	fresh.classList.add('loaded')

	iframe.parentNode.replaceChild(fresh, iframe)

	// Let the Vimeo autoplay / custom-controls system wire up the now-loaded
	// iframe — it normally binds at content_ready, before a lazy iframe has a src.
	if (window.laytheme && typeof window.laytheme.emit === 'function') {
		window.laytheme.emit('lay_iframe_lazyloaded', fresh)
	}
}

var initLazyLoadIframesOnScroll = function ($target) {
	var $iframes = $target.find('iframe.lay-iframe-lazyload[data-src]')

	if (!('IntersectionObserver' in window)) {
		// No observer support: load them so the videos still show up.
		$iframes.each(function () {
			loadIframe(this)
		})
		return
	}

	var observer = new IntersectionObserver(
		function (entries, obs) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					loadIframe(entry.target)
					obs.unobserve(entry.target)
				}
			})
		},
		{
			rootMargin: '100%', // start loading one viewport away, like the html5 video loader
		}
	)

	$iframes.each(function () {
		observer.observe(this)
	})
}

var load_lazy_iframes_controller = {
	initLazyLoadIframesOnScroll: function ($target) {
		initLazyLoadIframesOnScroll($target)
	},
	loadIframe: function (iframe) {
		loadIframe(iframe)
	},
}

export default load_lazy_iframes_controller
